"use client";

import { BSREye } from "./bsr/BSREye";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { EyeOpen as LegacyEyeOpen } from "./legacy/EyeOpen";

export const EyeOpen = createBSRExperimentIcon(LegacyEyeOpen, BSREye);
